/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

 const el = document.querySelector("#shopify-section-header")
 const observer = new IntersectionObserver( 
   ([e]) => e.target.classList.toggle("is-pinned", e.intersectionRatio < 1),
   { threshold: [1] }
 );
 
 observer.observe(el);

// For Express Order Section

// document.addEventListener('variant:changed', function(event) {
//   var variant = event.detail.variant; // Gives you access to the whole variant details
//   if (document.querySelector('.ProductMeta__VariantNumber')) {
//     document.querySelector('.ProductMeta__VariantNumber').innerHTML = variant.id;
//   }
// });
  
  
if (document.querySelector(".Express-Order-Form")) {
  document.querySelector(".Express-Order-Form").addEventListener('submit', function(e){
    e.preventDefault();
    var item_numbers = e.target.querySelectorAll('[name="item_number"]');
    var cart_data = [];
    var result = [];
    if (item_numbers.length) {
      for (let i=0; i<item_numbers.length; i++) {
        if (item_numbers[i].value) {
          cart_data.push({ id: item_numbers[i].value, quantity: 1});
        }
      }
    }

    addExpressOrder(cart_data);

  //   if (cart_data) {
  //     document.dispatchEvent(new CustomEvent('theme:loading:start')); // Then we add the product in Ajax

  //     fetch("/cart/add.js", {
  //       body: JSON.stringify({'items': cart_data}),
  //       credentials: 'same-origin',
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header

  //       }
  //     }).then(function (response) {
  //       document.dispatchEvent(new CustomEvent('theme:loading:end'));

  //       if (response.ok) {
  //         window.location.replace("/cart");

  //       } else {
  //         response.json().then(function (content) {
  //           console.log(content);
  //         });
  //       }
  //     });
  //   }

    return false;  
  });
}

async function addExpressOrder(cart_data) {
  document.dispatchEvent(new CustomEvent('theme:loading:start'));
  
  let result_html = [];
  for ( let i=0; i<cart_data.length; i++ ) {
    let response = await fetch("/cart/add.js", {
      body: JSON.stringify({'items': [cart_data[i]] }),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header

      }
    });
    if (response.ok) {
      result_html.push('<span class="Alert Alert--success">#'+cart_data[i].id+' has been successfully added.</span>');
    } else {
      result_html.push('<span class="Alert Alert--error">#'+cart_data[i].id+' could not be found.</span>');
    }
  }
  
  document.dispatchEvent(new CustomEvent('theme:loading:end'));
  
  var errorMessageElement = document.createElement('div');
  errorMessageElement.innerHTML = "";
  for ( let i=0; i<result_html.length; i++ ) {
    errorMessageElement.innerHTML += result_html[i];
  }
  document.querySelector(".Express-Order-Form").insertAdjacentElement('afterend', errorMessageElement);
  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
    bubbles: true
  }));
  setTimeout(function () {
    //window.location.replace("/cart");        
    document.querySelector('.Header__Icon[data-drawer-id="sidebar-cart"]').click();    
  }, 1000);
  setTimeout(function () {
    errorMessageElement.remove();
  }, 2500);
  
}
